export default {
      id: "pattern-plus-page-secondary-usage",
      viewBox: "0 0 157 158",
      url: "../icon/" + "icons.svg#pattern-plus-page-secondary-usage",
      toString: function () {
        return this.url;
      }
    }